// src/components/Modal.js
import React, { useEffect } from 'react';
import lenis from '../lenis'; // ⬅️ IMPORTANTE

function Modal({ isOpen, onClose, children }) {
    useEffect(() => {
        if (isOpen) {
            document.body.classList.add('overflow-hidden');

            // ⬅️ PAUSA EL SCROLL DEL FONDO
            if (lenis) lenis.stop();

        } else {
            document.body.classList.remove('overflow-hidden');

            // ⬅️ REACTIVA SCROLL DEL FONDO
            if (lenis) lenis.start();
        }

        // cleanup
        return () => {
            document.body.classList.remove('overflow-hidden');
            if (lenis) lenis.start();
        };
    }, [isOpen]);

    return (
        <div
            className={`fixed inset-0 z-50 flex items-center justify-center transition-opacity duration-300 ease-in-out 
                ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
            {/* Fondo oscuro con blur */}
            <div
                className="absolute inset-0 bg-black/60 backdrop-blur-md"
                onClick={onClose}
            ></div>

            {/* Contenedor del modal */}
            <div
                className={`relative bg-white text-black w-full max-w-2xl m-8 rounded-lg shadow-xl 
                    transform transition-all duration-300 ease-in-out 
                    ${isOpen ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}`}
            >
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-500 hover:text-gray-800"
                >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        />
                    </svg>
                </button>

                <div className="max-h-[80vh] overflow-y-auto p-4">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;

